export default "__VITE_ASSET__4ziqp1SIezY8m5A$hydsAQ__"